var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStar48Filled = function SvgIconStar48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.594 20.235a2.91 2.91 0 0 0-2.35-2l-7.33-1.06-3.28-6.61a2.9 2.9 0 0 0-5.2 0l-3.28 6.61-7.34 1.06a2.91 2.91 0 0 0-1.6 5l5.29 5.13-1.24 7.25a2.902 2.902 0 0 0 2.85 3.4c.471 0 .935-.117 1.35-.34l6.57-3.43 6.57 3.43a2.9 2.9 0 0 0 4.2-3.06l-1.25-7.25 5.29-5.13a2.899 2.899 0 0 0 .75-3Z",
    fill: "current"
  })));
};
export default SvgIconStar48Filled;